import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { Action } from 'rxjs/internal/scheduler/Action';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CreatePassword } from '../model/account/createPassword';
import { ExternalUserChangePassword } from '../model/account/externalUserChangePassword';
import { HttpResponseDto } from '../model/common/httpResponseDto';
import { RegisterOwner } from '../model/owner/registerOwner';


@Injectable({
  providedIn: 'root'
}) 
export class AccountService {
    [x: string]: any;
    private baseUrl = `${environment.apiUrl}`;
  
    constructor(private http: HttpClient,private readonly router: Router) {}
     httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
           'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
        })
      };

  
    registerOwner(model: RegisterOwner){
      
         this.http.post<RegisterOwner>(`${this.baseUrl}/customerEnrollmentRequest/save`, model, this.httpOptions)
          .pipe(
            catchError((error: any) => {
                // Handle the error here
                console.error('An error occurred:', error);
                // Optionally, re-throw the error or return a default value
                return throwError('Something went wrong');
              })
          ).subscribe(data => {
            console.log(data);
          });;
      }
      generateCode(email: string){
        this.http.post<HttpResponseDto>(`${this.baseUrl}/external/password/send-otp`, email, this.httpOptions).subscribe({
          next: (response) => {

            // Handle successful response
          //  console.log('Success:', response);
          },
          error: (error) => {
         
            // Handle error response
           // console.log(error)
            console.error('Error:', error);
          },
          complete: () => {
            // Optional: Handle completion
            console.log('Request completed');
          }
        });
 
     }

     changePassword(externalUserChangePassword : ExternalUserChangePassword): HttpResponseDto{
      let  success: boolean = false;
      let result!: HttpResponseDto;;
      this.http.post<HttpResponseDto>(`${this.baseUrl}/external/changePassword`, externalUserChangePassword, this.httpOptions).subscribe({
        next: (response) => {
          result =  response;
        },
        error: (error) => {
         return undefined;
        },
      });
      return result;
     }


  validateCode(email: string , opt :string): Observable<HttpResponseDto> {

   return this.http.post<HttpResponseDto>(`${this.baseUrl}/external/password/validate-otp/${email}`, opt, this.httpOptions)
   .pipe(tap(data => {
      return data
   }));
  }

  setNewPassword(model: CreatePassword): Observable<HttpResponseDto> {
    return this.http.post<HttpResponseDto>(`${this.baseUrl}/account/external/createLogin`, model, this.httpOptions)
   .pipe(tap(data => {
      return data
   }));
  }
  }
  